export default "__VITE_ASSET__BkhxUfBQ__"